import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  id: null,
  createdAt: null,
  registrationDate: null,
  login: '',
  email: '',
  firstName: '',
  lastName: '',
  // gender: '',
  // birthDate: '',
  phone: '',
  // country: {
  //   country_id: '',
  //   name: '',
  // },
  avatarUrl: null,
  gravatar: '',
  status: '',
  is2Fa: false,
  isPreferKyc: false,
};

export const userSlice = createSlice({
  name: 'user',
  initialState,
  reducers: {
    setUserId: (state, action) => {
      state.id = action.payload;
    },
    setUserCreatedAt: (state, action) => {
      state.createdAt = action.payload;
    },
    setUserRegistrationDate: (state, action) => {
      state.registrationDate = action.payload;
    },
    setUserLogin: (state, action) => {
      state.login = action.payload;
    },
    setUserEmail: (state, action) => {
      state.email = action.payload;
    },
    setUserFirstName: (state, action) => {
      state.firstName = action.payload;
    },
    setUserLastName: (state, action) => {
      state.lastName = action.payload;
    },
    // setUserGender: (state, action) => { state.gender = action.payload },
    // setUserBirthDate: (state, action) => { state.birthDate = action.payload },
    setUserPhone: (state, action) => {
      state.phone = action.payload;
    },
    // setUserCountry: (state, action) => { state.country = action.payload },
    setUserAvatar: (state, action) => {
      state.avatarUrl = action.payload;
    },
    setUserGravatar: (state, action) => {
      state.gravatar = action.payload;
    },
    setUserStatus: (state, action) => {
      state.status = action.payload;
    },
    setUserIs2Fa: (state, action) => {
      state.is2Fa = action.payload;
    },
    setUserIsPreferKyc: (state, action) => {
      state.isPreferKyc = action.payload;
    },

    resetUser: () => initialState,
  },
});

export const {
  setUserId,
  setUserCreatedAt,
  setUserRegistrationDate,
  setUserLogin,
  setUserEmail,
  setUserFirstName,
  setUserLastName,
  // setUserGender,
  // setUserBirthDate,
  setUserPhone,
  // setUserCountry,
  setUserAvatar,
  setUserGravatar,
  setUserStatus,
  setUserIs2Fa,
  setUserIsPreferKyc,

  resetUser,
} = userSlice.actions;

export default userSlice.reducer;
